import React from "react";
import { Link } from "react-router-dom";

/**
 * Official VS-Solutions logo — single source of truth.
 * Uses the uploaded image directly. No background box, border, circle, or shadow.
 * Preserves original proportions, colors, and quality.
 */
export default function VSLogo({ size = 40, showWordmark = false, dark = false, className = "" }) {
  return (
    <Link
      to="/"
      data-testid="vs-logo-home"
      aria-label="VS-Solutions"
      className={`inline-flex items-center gap-2.5 ${className}`}
    >
      <img
        src="/vs-logo.png"
        alt="VS-Solutions"
        width={size}
        height={size}
        style={{ height: size, width: "auto", display: "block" }}
        className="select-none"
        draggable={false}
      />
      {showWordmark && (
        <span
          className={`font-display font-bold tracking-tight text-lg leading-none ${dark ? "text-white" : "text-[#0A2540]"}`}
        >
          VS-Solutions
        </span>
      )}
    </Link>
  );
}
